(function(){
  document.querySelectorAll('[data-gal]').forEach(function(g){
    var main=g.querySelector('.gal-main'),th=g.querySelectorAll('.gal-th button');
    th.forEach(function(b,i){b.addEventListener('click',function(){main.scrollTo({left:main.clientWidth*i,behavior:'smooth'});});});
    main.addEventListener('scroll',function(){var i=Math.round(main.scrollLeft/main.clientWidth);th.forEach(function(b,k){b.classList.toggle('on',k===i);});},{passive:true});
  });
  document.querySelectorAll('[data-offers]').forEach(function(f){
    var cards=f.querySelectorAll('.of'),idIn=f.querySelector('input[name=id]'),sp=document.querySelectorAll('[data-sticky-price]'),sn=document.querySelectorAll('[data-sticky-name]');
    function sel(c){cards.forEach(function(x){x.classList.toggle('on',x===c);});var r=c.querySelector('input');r.checked=true;idIn.value=r.value;
      sp.forEach(function(e){e.textContent=c.dataset.price;});sn.forEach(function(e){e.textContent=c.dataset.name;});}
    cards.forEach(function(c){c.addEventListener('click',function(){sel(c);});});
    var on=f.querySelector('.of.on')||cards[0];if(on)sel(on);
  });
  var s=document.querySelector('.sticky-atc'),b=document.querySelector('[data-main-atc]');
  if(s&&b&&'IntersectionObserver' in window){new IntersectionObserver(function(e){s.classList.toggle('show',!e[0].isIntersecting&&e[0].boundingClientRect.top<0);}).observe(b);
    s.querySelector('button').addEventListener('click',function(){b.click();});}
})();
